/**
 * Componente para inicializar el override de console
 * Este componente se ejecuta solo en el cliente y es SEGURO
 */

'use client';

import { useEffect } from 'react';
import { initializeConsoleOverride } from '@/lib/console-override';

export default function ConsoleOverride() {
  useEffect(() => {
    // Inicializar el override de console solo en el cliente
    initializeConsoleOverride();
  }, []);

  // Este componente no renderiza nada visible
  return null;
}

